/***** SCRIPTS POUR GERER LES FORMULAIRES *****/

jQuery( document ).ready( function( $ ) {
    setupForms();
    
    function setupForms() {
        $('.wpcf7-form input[type="submit"], .wpcf7-form .btn-submit').click(testerFormulaire);
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            let formulaireID = $(event.target).children('.form').attr('id');
            $('.wpcf7-response-output').hide();
            $('.loading').removeClass('show');
            $("html, body").removeAttr('style');
            
            $(event.target).children('.form').fadeOut(400, function() {
                $(event.target).find('.validation-msg').fadeIn(400);
            });
        }, false );
    }
    
    // Fonction qui permet de tester les formulaires
    function testerFormulaire(e) {
        var fromId = $(this).parent().parent().parent().parent().attr('id');
        if(fromId === undefined) fromId = $(this).parent().parent().parent().parent().parent().attr('id');
        
        // vérification des saisies utilisateurs
        let nbChampVide = 0;
        $('#' + fromId+ ' .error-msg').fadeOut(200);
        $('#' + fromId+ ' .error').removeClass('error');
        $('#' + fromId+ ' .valid').removeClass('valid');
        
        // On vérifie que l'utilisateur a coché les cases RGPD
        if($('#' + fromId+ ' input[name="rgpd[]"]').prop( "checked" ) === false) {
            $('#' + fromId+ ' input[name="rgpd[]"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
            nbChampVide++;
        }
        
        // On vérifie s'il y a des boutons radios obligatoires
        $('#' + fromId+ ' .wpcf7-radio').each(function () {
            if($(this).find('input:checked').length === 0) {
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
                nbChampVide++;
            }else {
                $(this).addClass('valid');
            }
        });
        
        // On vérifie s'il y a des select list obligatoire
        $('#' + fromId+ ' select.wpcf7-validates-as-required').each(function () {
            if($(this).val() == '' || $(this).val() == ' ' || $(this).val() === '- Aucun -') {
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
                nbChampVide++;
            }else {
                $(this).addClass('valid');
            }
        });
        
        // On vérifie la saisie des champs obligatoire
        $('#' + fromId+ ' .form input.wpcf7-validates-as-required, #' + fromId+ ' .wpcf7-form input.wpcf7-validates-as-required, #' + fromId+ ' .form input.wpcf7-validates-as-number, #' + fromId+ ' .wpcf7-form input.wpcf7-validates-as-number').each(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                var name = $(this).attr('name');
                if(name === 'email') {
                    let emailVal = $(this).val();
                    $(this).val(emailVal.replace('.@', '@'));
                    var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                    if (regex.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else if(name === 'telephone') {
                    var regexPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
                    if (regexPhone.test($(this).val()) === false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else {
                    $(this).addClass('valid');
                }
            }
        });
        
        // On vérifie que les textarea requis sont renseignés
        $('#' + fromId+ ' .form textarea.wpcf7-validates-as-required, #' + fromId+ ' .wpcf7-form textarea.wpcf7-validates-as-required').each(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                $(this).addClass('valid');
            }
        });
        
        if(nbChampVide !== 0) {
            e.preventDefault();
            $("html, body").animate({ scrollTop: $('#' + fromId+ ' .error').offset().top - 160 }, 500);
        }else {
            $('body > .loading').addClass('show');
            $("html, body").animate({ scrollTop: $('#' + fromId+ ' .form').offset().top - 180 }, 500);
            $("html, body").css('overflow', 'hidden');
        }
    }
});
